(function () {
    'use strict';

    if (typeof window === 'undefined') {
        timePeriod(
            module.exports,
            require('../../../public/enums/timePeriod.js'),
            require('lodash')
        );
    } else {
        timePeriod(
            RivalIQ.module('props'),
            RivalIQ.enums.timePeriod,
            window._
        );
    }

    function timePeriod(module, timePeriodEnums, _) {
        module.supportedIntervals = supportedIntervals;
        module.durationSupported = durationSupported;
        module.timePeriodRestricted = isRestricted;

        /*
         * Returns true if the users timeperiod is restricted in a meaningful
         * way. We will probably want to make this more fine grained at some
         * point
         */
        function isRestricted(props) {
            return !(props.supported_main_time_periods & timePeriodEnums.mainPeriodType.LAST_NINETY_DAYS);
        }

        function supportedIntervals(props) {
            if (isRestricted(props)) {
                return [timePeriodEnums.interval.daily];
            }

            return _.values(timePeriodEnums.interval);
        }

        function durationSupported(props, duration) {
            if (isRestricted(props)) {
                // TODO this is way too boutique
                return duration.id === 'days_1' || duration.id === 'days_7';
            }

            return true;
        }
    }
})();
